module.exports = __webpack_public_path__ + "assets/1a3253b13e908dc235328accff907169.png";